import {
  // ShoppingCart,
  Heart,
} from "lucide-react";

const ProductCard = ({
  name,
  description,
  price,
  originalPrice,
  image,
  isProminent = false,
  features = [],
  onClick = () => {},
  id,
  subscribedProduct,
  jwtPayload,
}) => {
  return (
    <div className="product-card">
      <div className="product-image">
        <img src={image} alt={name} />
        <button className="heart-btn">
          <Heart style={{ width: "0.75rem", height: "0.75rem" }} />
        </button>
      </div>

      <div className="product-content">
        <h3
          className={`product-title ${
            isProminent ? "product-title-prominent" : "product-title-regular"
          }`}
        >
          {name}
        </h3>
        <p className="product-description">{description}</p>

        {isProminent && features.length > 0 && (
          <div className="product-features">
            {features.slice(0, 2).map((feature, index) => (
              <span key={index} className="feature-tag">
                {feature}
              </span>
            ))}
          </div>
        )}

        <div className="product-footer">
          <div className="price-section">
            <span
              className={`price-current ${
                isProminent
                  ? "price-current-prominent"
                  : "price-current-regular"
              }`}
            >
              {price}
            </span>
            {originalPrice && (
              <span className="price-original">{originalPrice}</span>
            )}
          </div>
          <button
            className={`btn ${
              subscribedProduct && jwtPayload ? "btn-hero-small" : "btn-outline"
            }`}
            onClick={onClick}
          >
            {/* <ShoppingCart style={{ width: "0.75rem", height: "0.75rem" }} /> */}
            {/* {isProminent ? "Buy Now" : "Access App"} */}

            {id === "1" || id === "2" || !subscribedProduct || !jwtPayload
              ? "Buy Now"
              : "Access App"}
            {/* {subscribedProduct && jwtPayload ? "Access App" : "Buy Now"} */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
